










































import {getModule} from 'vuex-module-decorators';
import {Component, Mixins} from 'vue-mixin-decorator';
import {BaseComponent} from '@/mixins/BaseComponent';

// @ts-ignore
import draggable from 'vuedraggable';

import {DashboardStore} from '@/store/Dashboard.store';

import Widget from '@/components/Utils/Widget.vue';
import NetworkStatusWidget from '@/components/Networking/NetworkStatusWidget.vue';
import LoraForwarderRunStatusWidget from '@/components/Lora/Forwarder/LoraForwarderRunStatusWidget.vue';
import SystemUpdateChecker from '@/components/System/SystemUpdateChecker.vue';
import SystemUpgradeWidget from '@/components/System/SystemUpgradeWidget.vue';
import SystemInfoWidget from '@/components/System/SystemInfoWidget.vue';
import SystemDiskUsageWidget from '@/components/System/Stats/SystemDiskUsageWidget.vue';
import SystemChangesWidget from '@/components/System/SystemChangesWidget.vue';

@Component({
  components: {
    draggable,
    SystemInfoWidget,
    SystemUpgradeWidget,
    SystemUpdateChecker,
    SystemDiskUsageWidget,
    SystemChangesWidget,
    LoraForwarderRunStatusWidget,
    NetworkStatusWidget,
    Widget,
  },
})
export default class DashboardPage extends Mixins<BaseComponent>(BaseComponent) {

  private dashboardStore: DashboardStore = getModule(DashboardStore, this.$store);

  private personalize = false;

  private enabledWidgets: string[] = [];

  private disabledWidgets: string[] = [];

  private mounted() {
    this.dashboardStore.loadWidgetsOrder();
    this.dashboardStore.loadDisabledWidgets();
  }

  private enablePersonalization() {
    this.enabledWidgets = this.dashboardStore.EnabledWidgets;
    this.disabledWidgets = this.dashboardStore.DisabledWidgets;

    this.personalize = true;
  }

  private disablePersonalization() {
    this.dashboardStore.persistDisabledWidgets(this.disabledWidgets);
    this.dashboardStore.persistWidgetsOrder(this.enabledWidgets);
    this.personalize = false;
  }

}
